import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PlanDetailsDialog from './plan-details-dialog.vue';

export default {
  data() {
    return {
      planDetailsDialog: null
    }
  },
  created() {
    this.planDetailsDialog = new ServiceConfirm(PlanDetailsDialog);
  },
  methods: {
    async showPlanDetailDialog() {
      this.$tracking.buyInteraction('plan details selected', this.trackingPlanName)
      await this.planDetailsDialog.confirm({
        title: this.title,
        trackingPlanName: this.trackingPlanName,
        planCategory: this.selectedPlan?.category,
      });
    },
  },
};
